
export function useLocalStorage(key) {
    const saveToLocalStorage = (data) => {
        localStorage.setItem(key, JSON.stringify(data));
    };

    const loadFromLocalStorage = () => {
        const savedData = localStorage.getItem(key);
        return savedData ? JSON.parse(savedData) : null;
    };

    const removeFromLocalStorage = () => {
        localStorage.removeItem(key);
    };

    return {
        saveToLocalStorage,
        loadFromLocalStorage,
        removeFromLocalStorage,
    };
}
